// Domains created before the pages table have no rows: their pages stay displayed, as the
// contact page always did.
function isPageActive(pages, name) {
    const page = (pages || []).find((item) => item.name === name);

    if (!page) {
        return true;
    }

    return !!Number(page.is_active);
}

module.exports = { isPageActive };
